var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"body body-anim-open"},[_c('img',{staticClass:"logo",attrs:{"src":require("../assets/logo-512.png")}}),_c('img',{staticClass:"title title-anim-open",attrs:{"src":_vm.title_src}})])
}
var staticRenderFns = []

export { render, staticRenderFns }